import { Form } from "antd";
import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

interface MobileProps {
  visible?: boolean;
  value?: string;
    onChange?: (values: {
      number: string;
      country_code: string;
      country_short_code: string;
    }) => void;
}

const AdminMobile: React.FC<MobileProps> = ({ visible, value, onChange }) => {
  const [phoneValue, setPhoneValue] = useState(value || "");

  const handleChange = (value: string, data: any) => {

    setPhoneValue(value);
    if (onChange) {
      onChange({
        number: value.length > 10 ? value.slice(2) : value,
        country_code: data.country_code,
        country_short_code: data.dialCode,
      });
    }
  };

  return (
    <Form.Item
      name={"mobile"}
      label="Mobile"
      // rules={[
      //   {
      //     required: true,
      //     message: "Mobile number is required",
      //   },
      // ]}
    >
      <PhoneInput
        country="in"
        inputStyle={{
          width: "100%",
        }}
        value={phoneValue || ""}
        onChange={handleChange}
      />
    </Form.Item>
  );
};

export default AdminMobile;
